import React from "react";
import { MdArrowBack, MdOutlineErrorOutline } from "react-icons/md";
import AutoHeightEmailFrame from "./AutoHeightEmailFrame";
import { elakayAutoText } from "../dataElakay";

const senderDisplayName = (senderId) =>
  senderId?.firstname
    ? `${senderId.firstname} ${senderId.lastname || ""}`.trim()
    : elakayAutoText("h_emk_inbox_elakay_marketing", "Elakay Marketing");

// Received Email view (spec §6-11/26 -- the most important part of this
// pass): a flex column filling 100% of .email-inbox-main's height --
// toolbar/header never scroll, the body takes the rest and scrolls on its
// own. The sidebar is rendered by the PARENT (emailInboxPage.jsx), never by
// this component -- it must never be hidden while an email is open.
const EmailReceivedView = ({ email, error, onBack }) => {
  if (error) {
    return (
      <div className="email-received-view">
        <div className="email-received-toolbar">
          <button type="button" className="email-received-back" onClick={onBack}>
            <MdArrowBack /> {elakayAutoText("h_emk_inbox_back", "Back to inbox")}
          </button>
        </div>
        <div className="email-inbox-state-error" role="alert">
          <MdOutlineErrorOutline />
          <strong>{elakayAutoText("h_emk_inbox_load_error", "Unable to load this email.")}</strong>
          <button type="button" onClick={onBack}>{elakayAutoText("h_emk_inbox_back", "Back to inbox")}</button>
        </div>
      </div>
    );
  }

  if (!email) {
    // Skeleton (spec §14): header + a large body skeleton, never a bare
    // "Loading..." floating in the middle of the page.
    return (
      <div className="email-received-view" aria-busy="true">
        <div className="email-received-toolbar">
          <button type="button" className="email-received-back" onClick={onBack}>
            <MdArrowBack /> {elakayAutoText("h_emk_inbox_back", "Back to inbox")}
          </button>
        </div>
        <div className="email-received-header">
          <div className="email-inbox-skeleton-bar" style={{ width: "55%", height: 20, marginBottom: 10 }} />
          <div className="email-inbox-skeleton-bar" style={{ width: "35%" }} />
        </div>
        <div className="email-received-body">
          <div className="email-inbox-skeleton-bar" style={{ width: "100%", height: "100%", borderRadius: "var(--emk-radius-md, 12px)" }} />
        </div>
      </div>
    );
  }

  return (
    <div className="email-received-view">
      <div className="email-received-toolbar">
        <button type="button" className="email-received-back" onClick={onBack}>
          <MdArrowBack /> {elakayAutoText("h_emk_inbox_back", "Back to inbox")}
        </button>
      </div>
      <header className="email-received-header">
        <h2>{email.subject || elakayAutoText("h_emk_inbox_no_subject", "(no subject)")}</h2>
        <div className="email-received-meta">
          <span><strong>{senderDisplayName(email.senderId)}</strong>{email.senderId?.email ? ` <${email.senderId.email}>` : ""}</span>
          <span className="email-received-meta-sep">·</span>
          <span>{elakayAutoText("h_emk_inbox_received", "Received")}: {new Date(email.sentAt || email.createdAt).toLocaleString()}</span>
        </div>
      </header>
      <div className="email-received-body">
        <AutoHeightEmailFrame html={email.htmlSnapshot || ""} width="100%" title={email.subject || elakayAutoText("h_84add5b2952787", "Email")} />
      </div>
    </div>
  );
};

export default EmailReceivedView;
